import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ElectricalServicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"electrical_services"}/>
}
